import { CascadiaJsonFormContext } from "@certn/forms";
import {
  CascadiaControlProps,
  withCascadiaControlProps,
} from "@certn/forms/src/wrappers/withCascadiaControlProps";
import { useContext } from "react";

import { UploadControl } from "./UploadControl";
import { UploadSummaryControl } from "./UploadSummaryControl";

/* eslint-disable react-hooks/rules-of-hooks */
function _UploadControl(props: CascadiaControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <UploadSummaryControl {...props} />;
  }

  return <UploadControl {...props} />;
}
/* eslint-enable react-hooks/rules-of-hooks */

_UploadControl.displayName = "UploadControl";

export const UploadControlRenderer = withCascadiaControlProps(_UploadControl);
